/*
 * Footer toogle containers
 */
var FooterWidgetFolder = function(element, options) {
	this.options = options;
	this.$element = $(element);
	this.$toggleContainer = null;
	this.init();
};

FooterWidgetFolder.defaults = {
	excludeWidgets: []
};

FooterWidgetFolder.prototype.init = function() {
	var _this = this;

	var $indicator = $($.parseHTML(
		'<span class="toggle-indicator"><span class="fa fa-angle-down"></span></span>'
	));


	this.$element.html('<div class="toggle-container">' + this.$element.html() + '</div>');
	var $title = this.$element.find('.widget-title');
	$title.detach().prependTo(this.$element);
	$title.prepend($indicator);

	this.$toggleContainer = this.$element.find('.toggle-container');


	$indicator.click(function(e) {
		e.preventDefault();
		e.stopPropagation();
		if(!Modernizr.mq('min-width: 992px')) {
			_this.toggle();
		}
	});

	$title.click(function(e) {
		e.preventDefault();
		e.stopPropagation();
		if(!Modernizr.mq('min-width: 992px')) {
			_this.toggle();
		}
	});


};

FooterWidgetFolder.prototype.toggle = function() {
	this.$element.toggleClass('active-widget');
	//this.$toggleContainer.slideToggle();
};

/**
 * FooterWidgetFolder jQuery plugin
 * @param option
 * @returns {*}
 * @constructor
 */
$.fn.FooterWidgetFolder = function( option ) {
	return this.each( function () {
		var $this = $(this);
		var options = $.extend(
			{},
			FooterWidgetFolder.defaults,
			$this.data(),
			typeof option == 'object' && option
		);

		/*
		 * Check whether is excluded
		 */
		var isExcluded = false;
		$.each(options.excludeWidgets, function(index, value) {
			if($this.hasClass(value)) {
				isExcluded = true;
			}
		});

		if(!isExcluded) {
			var data = $this.data('FooterWidgetFolder');
			if(!data) {
				$this.data('FooterWidgetFolder', (data = new FooterWidgetFolder(this, options)));
			}
		}
	});
};

